/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".clearButton[_ngcontent-%COMP%]{position:absolute;right:32px;top:50%;margin-top:-8px;width:16px;height:16px;cursor:pointer}.ui.clearable.dropdown[_ngcontent-%COMP%] > .text[_ngcontent-%COMP%]{right:4em}.readonlyValue[_ngcontent-%COMP%]{height:36px;display:flex;align-items:center;white-space:nowrap;overflow-x:hidden;text-overflow:ellipsis}\n/*# sourceMappingURL=dx-combobox.component.css.map*/"];
export { styles as styles };
